import { toInteger } from "lodash";

export function formatGericParsedDataConnectionResource(productData, normalizedSizesDictionary, retailerMargin) {
  const { margin } = retailerMargin;

  let isAllStandardSizes = true;
  const sizes = productData.sizes.map(s => {
    const { size, id, quantity } = s;
    // eslint-disable-next-line security/detect-object-injection
    const normalized = normalizedSizesDictionary[size];
    if (isAllStandardSizes && !normalized) {
      isAllStandardSizes = false;
    }

    return {
      id,
      size,
      quantity,
      normalized: normalized || "-"
    };
  });

  const incomingWholesale = Number(productData.prices.wholesale).toFixed(2);
  const retail = Number(Number(productData.prices.retail).toFixed(2));
  const compareAtPrice = Number(Number(productData.prices.compare_at_price).toFixed(2));
  const calculatedWholesalePrice = Number(productData.prices.calculated_wholesale_cost);

  if (productData.parsed_data_version === 1 || productData.parsed_data_version === 2) {
    return {
      title: productData.title,
      color: productData.color ?? "",
      incomingBrand: productData.incoming_brand,
      brand: productData?.brand && `${productData.brand}`,
      retailerDescription: productData.description ?? "",
      sizes,
      sku: productData.sku,
      images: productData.images || [],
      wholesale: calculatedWholesalePrice,
      incomingPrices: {
        wholesale: incomingWholesale,
        retail,
        compareAtPrice,
      },
      hasWholesale: incomingWholesale > 0,
      isAllStandardSizes,
      isWholesaleCalculatedFromMargin: (
        calculatedWholesalePrice
        && incomingWholesale
        && toInteger(margin) >= 0
        && (Number(incomingWholesale) !== Number(calculatedWholesalePrice))
      )
    };
  }
  throw new Error(`unsupported generic_parsed_data version: ${productData.parsed_data_version}`);
}
